module.exports = __webpack_public_path__ + "static/media/kiss.4521189d.svg";